import React, { useState } from 'react'

const Contact: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  })

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          access_key: '54e2a0d5-3b4d-41a8-bc8c-554209bea394',
          name: formData.name,
          email: formData.email,
          message: formData.message,
          subject: 'New Contact Form Submission from RobotStack',
        }),
      })
      
      const data = await response.json()
      
      if (data.success) {
        alert('MESSAGE TRANSMITTED. WE WILL RESPOND SHORTLY.')
        setFormData({ name: '', email: '', message: '' })
      } else {
        alert('Error sending message. Please try again.')
      }
    } catch (error) {
      console.error('Error:', error)
      alert('Error sending message. Please try again.')
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  return (
    <section className="border-t border-white/20 section-padding">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-mono mb-4">
            Contact
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-black border border-white/30 text-white font-mono focus:border-white focus:outline-none"
              placeholder="Enter your name"
            />
          </div>
          
          <div>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 bg-black border border-white/30 text-white font-mono focus:border-white focus:outline-none"
              placeholder="Enter your email"
            />
          </div>
          
          <div>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={6}
              className="w-full px-4 py-3 bg-black border border-white/30 text-white font-mono focus:border-white focus:outline-none resize-none"
              placeholder="What's on your mind?"
            />
          </div>
          
          <button
            type="submit"
            className="w-full btn-primary text-lg py-4 font-mono"
          >
            Send
          </button>
        </form>

        <div className="mt-12 text-center text-sm text-gray-400 font-mono">
          <p>I'll get back to you soon.</p>
        </div>
      </div>
    </section>
  )
}

export default Contact 